import * as React from "react";
import useSearchable from "../../hooks/useSearchable";
import { FormikChoiceT } from "../Forms/Formik/choiceFieldTypes";
import SingleOrMultiAutocomplete, {
  SingleOrMultiAutocompletePropsT,
} from "./SingleOrMultiAutocomplete";

export type StaticAutocompletePropsT = Omit<SingleOrMultiAutocompletePropsT, "canCreate"> & {
  multiple?: boolean;
  name: string;
  suggestions: FormikChoiceT[];
  searchFields?: string[];
};

export type StaticAutocompleteWrapperPropsT = Omit<
  StaticAutocompletePropsT,
  "name" | "suggestions"
>;

function StaticAutocomplete({
  searchFields = ["name"],
  suggestions,
  multiple = false,
  ...props
}: StaticAutocompletePropsT): React.ReactElement {
  const { results, setQuery } = useSearchable(suggestions, searchFields);
  return (
    <SingleOrMultiAutocomplete
      {...props}
      multiple={multiple}
      onSuggestionsFetchRequested={(q: string): Promise<void> => Promise.resolve(setQuery(q))}
      shouldRenderSuggestions={(): boolean => !!results.length}
      clearSuggestions={(): void => setQuery("")}
      suggestions={results}
    />
  );
}

export default StaticAutocomplete;
